module.exports = __webpack_public_path__ + "static/apple-icon-120x120-e936ab03ec81474c993d0b1903c56e42.png";